module.exports = __webpack_public_path__ + "static/media/processing-system (1).f46f973b.svg";